import { gql } from "apollo-boost";

export const fragments = {
  attachment: gql`
    fragment ServiceAttachmentsAttachment on Attachment {
      id
      name
      originalFilename
      byteSize
      attachmentType
      contentType
      createdAt
      updatedAt
      transmittal {
        id
      }
      versions {
        original
      }
      uploader {
        id
        name
        email
      }
      contract {
        id
        amountInCents
        effectiveDate
        cancelled
      }
    }
  `
};

export default gql`
  query ServiceAttachmentsQuery($serviceId: ID!) {
    attachments(serviceId: $serviceId) {
      ...ServiceAttachmentsAttachment
    }
  }
  ${fragments.attachment}
`;



// WEBPACK FOOTER //
// ./src/queries/ServiceAttachments.js